var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSucessFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5,
    cy: 60.5,
    rx: 43.5,
    ry: 39.5,
    fill: "#BFF736"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.446 17.5549C79.0399 -5.85162 40.9614 -5.85162 17.5549 17.5549C-5.85162 40.9562 -5.85162 79.0448 17.5549 102.446C29.2557 114.152 44.6281 120 60.0005 120C75.3729 120 90.7404 114.152 102.446 102.446C125.853 79.0448 125.853 40.9562 102.446 17.5549ZM93.5519 43.5274L58.5349 78.5446C57.5595 79.5201 56.2789 80.0104 54.9981 80.0104C53.7176 80.0104 52.4368 79.5201 51.4613 78.5446L31.4517 58.5349C29.4958 56.5791 29.4958 53.4174 31.4517 51.4616C33.4075 49.5057 36.5691 49.5057 38.525 51.4616L54.9981 67.9347L86.4786 36.4542C88.4344 34.4984 91.5961 34.4984 93.5519 36.4542C95.5078 38.4099 95.5078 41.5715 93.5519 43.5274Z",
    fill: "#3F4346"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessFull);
export default __webpack_public_path__ + "static/media/sucessFull.6f416825cfc9321a663ea011fec1a6fb.svg";
export { ForwardRef as ReactComponent };